const QUARTERS_PER_HOUR = 4;
const DECIMAL_HOURS_PATTERN = /^(\d+(\.\d*)?|\.\d+)$/;

export const parseDecimalHours = (text: string): number | null => {
  const value = text.trim().replace(',', '.');
  if (!DECIMAL_HOURS_PATTERN.test(value)) return null;

  return Number(value);
};

export const roundToQuarterHour = (hours: number): number => Math.round(hours * QUARTERS_PER_HOUR) / QUARTERS_PER_HOUR;

export const normalizeDecimalHours = (text: string): string => {
  const hours = parseDecimalHours(text);
  if (hours === null) return text;

  return roundToQuarterHour(hours).toFixed(2);
};
